module.exports = "<li ng-class=\"{'active': active, 'disabled': disabled}\"> <a href ng-click=select()>{{heading}}</a> </li>";